import { Link } from "react-router-dom"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

type LinkType = {
  label: string;
  href: string;
}

type LoginRegisterQuestionLinkProps = {
  mainQuestion: string;
  link: LinkType
}

export default function LoginRegisterQuestionLink(props: LoginRegisterQuestionLinkProps) {
  const { mainQuestion, link } = props

  return (
    <LoginLinkWrapper>
      <Typography>{mainQuestion}</Typography>
      <Link to={link.href}>{link.label}</Link>
    </LoginLinkWrapper>
  )
}

const LoginLinkWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.2rem",
  gap: "4px",
  marginTop: "2.4rem",

  "& p": {
    color: theme.palette.gray["11"],
    fontWeight: 300,
    fontSize: "1.2rem",
  },

  "& a": {
    color: theme.palette.primary["6"],
    fontWeight: 500,
    textDecoration: "none",
  }
}))
